import * as React from "react";
import { useNavigate } from "react-router";
import { LoginForm } from "@/ui/components/LoginForm";
import { AuthLayout } from "@/ui/layouts";
import { useAuthViewModel } from "@/viewModels/useAuthViewModel";

/**
 * Login Page
 *
 * Pure page component following MVVM pattern.
 * - No business logic (all in ViewModel)
 * - Single useEffect for lifecycle (onMount)
 * - Delegates all user actions to ViewModel
 *
 * Story: 3.1 - Authentication UI with Amplify JS
 * Story: 3.2.b - Navigate to signup page via onSignUp prop
 */
export default function LoginPage() {
  const viewModel = useAuthViewModel();
  const navigate = useNavigate();

  // Only allowed useEffect - lifecycle management
  React.useEffect(() => {
    const cleanup = viewModel.onMount();
    return cleanup;
  }, [viewModel.onMount]);

  return (
    <AuthLayout>
      <LoginForm
        onSignIn={(data) => viewModel.actions.login(data.email, data.password, data.rememberMe)}
        onGoogleSignIn={() => viewModel.actions.socialLogin('google')}
        onAppleSignIn={() => viewModel.actions.socialLogin('apple')}
        onForgotPassword={() => navigate('/auth/forgot-password')}
        onSignUp={() => navigate('/auth/signup')}
        error={viewModel.computed.errorMessage}
        fieldErrors={viewModel.state.fieldErrors || undefined}
        googleLoading={viewModel.state.googleLoading}
        appleLoading={viewModel.state.appleLoading}
        signInLoading={viewModel.state.signInLoading}
      />
    </AuthLayout>
  );
}
